import { withoutEmpty } from "./blockContent";
import type { BlockButton, ButtonVariant } from "./types";

export function emptyButton(variant: ButtonVariant): BlockButton {
  return { label: "", href: "", variant };
}

export function buttonOrNothing(button: BlockButton): BlockButton | undefined {
  const trimmed = { ...button, label: button.label.trim(), href: button.href.trim() };
  return trimmed.label === "" && trimmed.href === "" ? undefined : trimmed;
}

export function withoutEmptySection<T extends object>(record: T, keys: string[] = []): T {
  return withoutEmpty(record, ["heading", "anchorId", ...keys]);
}
